import { StoreState } from "../../store/store.interface";

/*----- CREATE SELECTORS ------*/

export const getShareCartId = (state: StoreState) =>
    state.shareCartState.data?.content?.shared_cart_key || undefined;

export const getShareCartStatus = (state: StoreState) => state.shareCartState.status;
